module.exports = __webpack_public_path__ + "img/S_C_H_A_U_K_E_L_N.94efd2a5.svg";